import Modal from "./Modal";
import Button from "../ui/Button";

/**
 * Lightweight alert modal: sm-sized Modal with a single "Got it" footer button.
 * Use for informational one-action alerts (e.g. PendingHandoffAlert, DailyBankBalanceAlert).
 */
export default function AlertModal({ isOpen, onClose, title, children }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={<Button onClick={onClose}>Got it</Button>}
    >
      {children}
    </Modal>
  );
}
